/**
 * BAUSTEIN 12 (a) — DIE MARKE „DEINE ANTWORT HÄNGT“ an der Bühnenkarte.
 *
 * Fall b-alltagshandbuch-sparmodi-20261008: Rafaels Antwort hing 17 h, der Grund (Codex-Zugang
 * erschöpft) stand nur im Verlauf. Der Server rechnet `antwort_haengt` (lib/guide-buehnen.ts
 * `haengendeAntwort`); hier steht nur, wie es gesagt wird — Grund und Reset-Zeit, nie geraten.
 */
export type AntwortHaengt = {
  anzahl: number;
  seit: string;
  grund: string;
  kein_zugang: { konto: string; frei_ab: string | null } | null;
};

function zeitpunkt(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const zwei = (n: number) => String(n).padStart(2, '0');
  return `${zwei(d.getUTCDate())}.${zwei(d.getUTCMonth() + 1)}. ${zwei(d.getUTCHours())}:${zwei(d.getUTCMinutes())}Z`;
}

/** Kurzform für die Karte: was hängt und warum — die Reset-Zeit gehört dazu, wenn es ein Zugang ist. */
export function antwortHaengtKurz(h: AntwortHaengt): string {
  const was = h.anzahl === 1 ? 'Deine Antwort hängt' : `${h.anzahl} Antworten von dir hängen`;
  if (!h.kein_zugang) return `${was} — nicht beim Berater angekommen`;
  return `${was} — KI-Zugang ${h.kein_zugang.konto} erschöpft, `
    + (h.kein_zugang.frei_ab ? `frühestens frei ${zeitpunkt(h.kein_zugang.frei_ab)}` : 'Reset-Zeit unbekannt');
}

/** Langform für den Tooltip: der woertliche Fehler des letzten Versuchs. */
export function antwortHaengtLang(h: AntwortHaengt): string {
  return `${antwortHaengtKurz(h)}\nseit ${zeitpunkt(h.seit)}\nLetzter Versuch: ${h.grund}`;
}
